import { styled } from '@linaria/react'
import { MEDIA } from 'vars/media'

export const TopNumberSC = styled.svg`
  pointer-events: none;
`
export const TopNumber1SC = styled(TopNumberSC)``
export const TopNumber2SC = styled(TopNumberSC)``
export const TopNumber3SC = styled(TopNumberSC)``
export const TopNumber4SC = styled(TopNumberSC)``
export const TopNumber5SC = styled(TopNumberSC)``
export const TopNumber6SC = styled(TopNumberSC)``
export const TopNumber7SC = styled(TopNumberSC)``
export const TopNumber8SC = styled(TopNumberSC)``
export const TopNumber9SC = styled(TopNumberSC)``

export const TopDoubleDigitNumberSC = styled.svg`
  pointer-events: none;
`
export const TopNumber10SC = styled(TopDoubleDigitNumberSC)``

export const VodVerticalNumberSC = styled.div`
  ${TopNumberSC}, ${TopDoubleDigitNumberSC} {
    height: 42%;
    position: absolute;
    bottom: 11.2%;
  }

  ${TopNumberSC} {
    left: 20.5%;
  }
  ${TopNumber1SC} {
    width: 25.24%;
  }
  ${TopNumber2SC} {
    width: 24.46%;
  }
  ${TopNumber3SC} {
    width: 24.06%;
  }
  ${TopNumber4SC} {
    width: 28.6%;
  }
  ${TopNumber5SC} {
    width: 25.25%;
  }
  ${TopNumber6SC} {
    width: 26.43%;
  }
  ${TopNumber7SC} {
    width: 25.25%;
  }
  ${TopNumber8SC} {
    width: 26.82%;
  }
  ${TopNumber9SC} {
    width: 26.43%;
  }

  ${TopDoubleDigitNumberSC} {
    left: 12.6%;
  }
  ${TopNumber10SC} {
    width: 46.15%;
  }
`

export const VodHorizontalNumberSC = styled.div`
  ${TopNumberSC}, ${TopDoubleDigitNumberSC} {
    height: 54.36%;
    position: absolute;
    bottom: 15.9%;
  }

  ${TopNumberSC} {
    left: 10.34%;
  }
  ${TopNumber1SC} {
    width: 16.03%;
  }
  ${TopNumber2SC} {
    width: 15.69%;
  }
  ${TopNumber3SC} {
    width: 15.52%;
  }
  ${TopNumber4SC} {
    width: 17.93%;
  }
  ${TopNumber5SC} {
    width: 16.21%;
  }
  ${TopNumber6SC} {
    width: 16.72%;
  }
  ${TopNumber7SC} {
    width: 16.21%;
  }
  ${TopNumber8SC} {
    width: 16.9%;
  }
  ${TopNumber9SC} {
    width: 16.72%;
  }

  ${TopDoubleDigitNumberSC} {
    left: 5.34%;
  }
  ${TopNumber10SC} {
    width: 29.48%;
  }
`

export const TvHorizontalNumberSC = styled.div`
  ${TopNumberSC}, ${TopDoubleDigitNumberSC} {
    height: 70.6%;
    position: absolute;
    bottom: 12.17%;
  }

  ${TopNumberSC} {
    left: 10%;
  }
  ${TopNumber1SC} {
    width: 19.5%;
  }
  ${TopNumber2SC} {
    width: 19.25%;
  }
  ${TopNumber3SC} {
    width: 19%;
  }
  ${TopNumber4SC} {
    width: 22%;
  }
  ${TopNumber5SC} {
    width: 19.75%;
  }
  ${TopNumber6SC} {
    width: 20.75%;
  }
  ${TopNumber7SC} {
    width: 20%;
  }
  ${TopNumber8SC} {
    width: 20.75%;
  }
  ${TopNumber9SC} {
    width: 20.75%;
  }

  ${TopDoubleDigitNumberSC} {
    left: 5%;
  }
  ${TopNumber10SC} {
    width: 36.25%;
  }
`

export const EventVerticalNumberSC = styled.div`
  ${TopNumberSC}, ${TopDoubleDigitNumberSC} {
    height: 33.7%;
    position: absolute;
    bottom: 28.5%;

    ${MEDIA.MIN_600} {
      height: 33.1%;
      bottom: 30%;
    }

    ${MEDIA.MIN_768} {
      height: 34.92%;
      bottom: 26.06%;
    }

    ${MEDIA.MIN_1240} {
      height: 35.86%;
      bottom: 24.64%;
    }

    ${MEDIA.MIN_1440} {
      height: 37.3%;
      bottom: 22.3%;
    }

    ${MEDIA.MIN_1640} {
      bottom: 20.65%;
    }
  }

  ${TopNumberSC} {
    left: 20.51%;
  }
  ${TopNumber1SC} {
    width: 25.24%;
  }
  ${TopNumber2SC} {
    width: 24.46%;
  }
  ${TopNumber3SC} {
    width: 24.06%;
  }
  ${TopNumber4SC} {
    width: 28.6%;
  }
  ${TopNumber5SC} {
    width: 25.25%;
  }
  ${TopNumber6SC} {
    width: 26.43%;
  }
  ${TopNumber7SC} {
    width: 25.25%;
  }
  ${TopNumber8SC} {
    width: 26.82%;
  }
  ${TopNumber9SC} {
    width: 26.43%;
  }

  ${TopDoubleDigitNumberSC} {
    left: 12.62%;
  }
  ${TopNumber10SC} {
    width: 46.15%;
  }
`

export const EventHorizontalNumberSC = styled.div`
  ${TopNumberSC}, ${TopDoubleDigitNumberSC} {
    height: 38.75%;
    position: absolute;
    bottom: 40%;

    ${MEDIA.MIN_600} {
      height: 40%;
      bottom: 38.1%;
    }

    ${MEDIA.MIN_1240} {
      height: 42.92%;
      bottom: 33.58%;
    }

    ${MEDIA.MIN_1440} {
      height: 44.35%;
      bottom: 31.37%;
    }

    ${MEDIA.MIN_1640} {
      height: 43.04%;
      bottom: 33.38%;
    }

    ${MEDIA.MIN_1920} {
      height: 44.92%;
      bottom: 30.49%;
    }
  }

  ${TopNumberSC} {
    left: 10.34%;
  }
  ${TopNumber1SC} {
    width: 16%;
  }
  ${TopNumber2SC} {
    width: 15.69%;
  }
  ${TopNumber3SC} {
    width: 15.52%;
  }
  ${TopNumber4SC} {
    width: 17.93%;
  }
  ${TopNumber5SC} {
    width: 16.21%;
  }
  ${TopNumber6SC} {
    width: 16.72%;
  }
  ${TopNumber7SC} {
    width: 16.21%;
  }
  ${TopNumber8SC} {
    width: 16.9%;
  }
  ${TopNumber9SC} {
    width: 16.72%;
  }

  ${TopDoubleDigitNumberSC} {
    left: 5.34%;
  }
  ${TopNumber10SC} {
    width: 29.48%;
  }
`
